(function () {
  window.SRDDesignerCalibration = {
    standard_signs: {
      preview_scale: {
        fit: 'contain',
        align_x: 'center',
        align_y: 'center'
      },
      templates: {
        splash: {
          writable_area_center_x: null,
          writable_area_center_y: null,
          writable_area_width: null,
          writable_area_height: null,
          default_horizontal_alignment: 'center',
          default_vertical_alignment: 'center',
          default_padding: 0
        },
        danger: {
          writable_area_center_x: 50,
          writable_area_center_y: 62,
          writable_area_width: 76,
          writable_area_height: 35.5,
          default_horizontal_alignment: 'center',
          default_vertical_alignment: 'center',
          default_padding: 1.5
        },
        warning: {
          writable_area_center_x: 50,
          writable_area_center_y: 62,
          writable_area_width: 76,
          writable_area_height: 35.5,
          default_horizontal_alignment: 'center',
          default_vertical_alignment: 'center',
          default_padding: 1.5
        },
        warning_orange_black: {
          writable_area_center_x: 50,
          writable_area_center_y: 60,
          writable_area_width: 76,
          writable_area_height: 37,
          default_horizontal_alignment: 'center',
          default_vertical_alignment: 'center',
          default_padding: 1.5
        },
        caution: {
          writable_area_center_x: 50,
          writable_area_center_y: 60,
          writable_area_width: 76,
          writable_area_height: 37,
          default_horizontal_alignment: 'center',
          default_vertical_alignment: 'center',
          default_padding: 1.5
        },
        notice: {
          writable_area_center_x: 50,
          writable_area_center_y: 60,
          writable_area_width: 76,
          writable_area_height: 37,
          default_horizontal_alignment: 'center',
          default_vertical_alignment: 'center',
          default_padding: 1.5
        }
      }
    },
    blank_canvas: {
      preview_scale: {
        fit: 'contain',
        align_x: 'center',
        align_y: 'center'
      },
      safe_area: {
        inset: 0.06,
        stroke_width: 2
      }
    },
    nitrous: {
      preview_scale: {
        fit: 'contain',
        align_x: 'center',
        align_y: 'center'
      },
      bottle_sizes: {
        '2 LB Bottle': {
          finished_width: 3.6,
          finished_height: 4.6,
          finished_size_label: '3.6 x 4.6 in',
          calibration_profile: 'nitrous_2lb',
          package_quantity: 7,
          package_price: 39.89,
          material_package_prices: {
            standard: 39.89,
            reflective: 43.89
          },
          weight_values: ['6 LBS', '4 LBS', '2 LBS'],
          weight_overlay: {
            x: 0.528,
            y: 0.742,
            width: 0.235,
            fontSize: 1.07,
            lineSpacing: 0.51,
            alignment: 'left',
            background: 'transparent'
          },
          mobile_weight_overlay_override: {
            x: 0.583,
            y: 0.742,
            width: 0.235,
            fontSize: 1.07,
            lineSpacing: 0.51,
            alignment: 'left'
          },
          header_area: {
            x: 0.16,
            y: 0.115,
            width: 0.68,
            height: 0.23
          },
          preview_scale: 1
        },
        '5 LB Bottle': {
          finished_width: 5.1,
          finished_height: 6.1,
          finished_size_label: '5.1 x 6.1 in',
          calibration_profile: 'nitrous_5lb',
          package_quantity: 5,
          package_price: 27.89,
          material_package_prices: {
            standard: 27.89,
            reflective: 44.89
          },
          weight_values: ['13.4 LBS', '8.4 LBS', '5 LBS'],
          weight_overlay: {
            x: 0.57,
            y: 0.743,
            width: 0.038,
            fontSize: 0.94,
            lineSpacing: 0.51,
            alignment: 'left',
            background: 'transparent'
          },
          header_area: {
            x: 0.16,
            y: 0.115,
            width: 0.68,
            height: 0.23
          },
          preview_scale: 1
        },
        '10 LB Bottle': {
          finished_width: 5.7,
          finished_height: 7.6,
          finished_size_label: '5.7 x 7.6 in',
          calibration_profile: 'nitrous_10lb',
          package_quantity: 4,
          package_price: 28.89,
          material_package_prices: {
            standard: 28.89,
            reflective: 45.89
          },
          weight_values: ['24 LBS', '14 LBS', '10 LBS'],
          weight_overlay: {
            x: 0.562,
            y: 0.738,
            width: 0.185,
            fontSize: 1.05,
            lineSpacing: 0.5,
            alignment: 'left',
            background: 'transparent'
          },
          mobile_weight_overlay_override: {
            x: 0.58,
            y: 0.738,
            width: 0.185,
            fontSize: 1.05,
            lineSpacing: 0.5,
            alignment: 'left'
          },
          header_area: {
            x: 0.16,
            y: 0.115,
            width: 0.68,
            height: 0.23
          },
          preview_scale: 1
        },
        '15 LB Bottle': {
          finished_width: 5.7,
          finished_height: 7.6,
          finished_size_label: '5.7 x 7.6 in',
          calibration_profile: 'nitrous_15lb',
          package_quantity: 4,
          package_price: 28.89,
          material_package_prices: {
            standard: 28.89,
            reflective: 45.89
          },
          weight_values: ['33 LBS', '18 LBS', '15 LBS'],
          weight_overlay: {
            x: 0.572,
            y: 0.741,
            width: 0.174,
            fontSize: 1.17,
            lineSpacing: 0.42,
            alignment: 'left',
            background: 'transparent'
          },
          mobile_weight_overlay_override: {
            x: 0.59,
            y: 0.741,
            width: 0.174,
            fontSize: 1.17,
            lineSpacing: 0.42,
            alignment: 'left'
          },
          header_area: {
            x: 0.16,
            y: 0.115,
            width: 0.68,
            height: 0.23
          },
          preview_scale: 1
        },
        '20 LB Bottle': {
          finished_width: 6,
          finished_height: 8,
          finished_size_label: '6 x 8 in',
          calibration_profile: 'nitrous_20lb',
          package_quantity: 4,
          package_price: 29.89,
          material_package_prices: {
            standard: 29.89,
            reflective: 46.89
          },
          weight_values: ['45 LBS', '25 LBS', '20 LBS'],
          weight_overlay: {
            x: 0.564,
            y: 0.74,
            width: 0.185,
            fontSize: 1.12,
            lineSpacing: 0.51,
            alignment: 'left',
            background: 'transparent'
          },
          mobile_weight_overlay_override: {
            x: 0.582,
            y: 0.74,
            width: 0.185,
            fontSize: 1.12,
            lineSpacing: 0.51,
            alignment: 'left'
          },
          header_area: {
            x: 0.16,
            y: 0.115,
            width: 0.68,
            height: 0.23
          },
          preview_scale: 1
        }
      },
      headers: {
        nitrous_oxide_performance: {
          x: 0.16,
          y: 0.118,
          width: 0.68,
          height: 0.23,
          scale: 1.45,
          rotation: 0
        },
        nos: {
          x: 0.163,
          y: 0.118,
          width: 0.68,
          height: 0.23,
          scale: 1.25,
          rotation: 0
        },
        nx: {
          x: 0.16,
          y: 0.115,
          width: 0.68,
          height: 0.23,
          scale: 1.32,
          rotation: 0
        },
        no: {
          x: 0.163,
          y: 0.115,
          width: 0.68,
          height: 0.23,
          scale: 1.62,
          rotation: 0
        },
        induction_solutions: {
          x: 0.16,
          y: 0.115,
          width: 0.68,
          height: 0.23,
          scale: 1.17,
          rotation: 0
        },
        custom_art: {
          x: 0.16,
          y: 0.115,
          width: 0.68,
          height: 0.23,
          scale: 1.12,
          rotation: 0
        }
      }
    },
    future_product_families: {}
  };
})();
